(async () => {
    const { Core } = await importModule('Core');
    const {
        parseHTML,
        $clone,
    } = await importModule('Utils');

    // Mobile : feuille qui monte depuis le bas ; ordinateur : cadre centré (fondu).
    const MOBILE_QUERY = '(max-width: 767px)';

    customElements.define('cart-notification', class extends Core {
        subscriptions = {
            'cart:update': '_update'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'notification' });
            this.subscribe('cart:update', { global: true });
        }

        async _update({ notification }) {
            if (!notification?.section) return;
            const $doc = parseHTML(notification.section);
            this.$container = $clone($doc.querySelector('[data-content]'));
            this._openModal();
            this._watchProPrice();
        }

        _openModal() {
            const isMobile = window.matchMedia(MOBILE_QUERY).matches;
            this.publish('modal:open', {
                content: this.$container,
                position: isMobile ? 'bottom-center' : 'center',
                animation: isMobile ? 'slideBottom' : 'fade'
            })
        }

        // Clients balisés : le prix de Shopify est le prix B2C. On ne révèle le
        // prix que lorsque l'app WPD l'a réécrit (elle injecte un
        // .wpd-ext-compare-at-price) ; sinon il reste masqué.
        _watchProPrice() {
            const root = this.$container;
            const target = root && root.querySelector('[data-pro-price]');
            if (!target) return;

            const reveal = () => {
                if (!target.querySelector('.wpd-ext-compare-at-price')) return false;
                target.classList.add('@revealed');
                return true;
            };
            if (reveal()) return;

            const observer = new MutationObserver(() => {
                if (reveal()) observer.disconnect();
            });
            observer.observe(target, { childList: true, subtree: true });
            setTimeout(() => observer.disconnect(), 8000);
        }
    })
})();
